var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.646446 3.64644C0.451187 3.8417 0.451187 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.73079 4.34027 7.73079 4.53553 7.53553C4.7308 7.34027 4.7308 7.02368 4.53553 6.82842L1.70711 3.99999L4.53553 1.17157C4.7308 0.976305 4.7308 0.659723 4.53553 0.464461C4.34027 0.269198 4.02369 0.269198 3.82843 0.464461L0.646446 3.64644ZM67 3.5L1 3.49999L1 4.49999L67 4.5L67 3.5Z","fill":"#D9D9D9"}));
}

ArrowLeft.defaultProps = {"width":"67","height":"8","viewBox":"0 0 67 8","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
